import React, { useState } from 'react';
import PropTypes from 'prop-types';
import api from '../api/client';
import { Button, PasswordInput } from '../components/common';

/**
 * Authentication/Login Screen
 */
const AuthScreen = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await api.post('/auth/login', { email, password });
      onLogin(result.user, result.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title" style={{ textAlign: 'center' }}>Meeting<span style={{ color: 'var(--color-primary)' }}>Manager</span></h1>
        <p style={{ marginBottom: '1rem', color: 'var(--color-text-muted)', textAlign: 'center' }}>
          Sign in to continue
        </p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <Button
            type="submit"
            variant="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? 'Please wait...' : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  );
};

AuthScreen.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default AuthScreen;
